import React from 'react';
import ReactDOM from 'react-dom';

import { HashRouter } from 'react-router-dom'; // 少量公共样式
import 'tdesign-react/es/style/index.css';
import './index.css';
import App from './App';
import TPSSLaoyout from './tpss/pages/comps/Layout';

ReactDOM.render(
  <HashRouter>
    <App layout={<TPSSLaoyout />} />
  </HashRouter>,
  document.getElementById('root')
);
